// src/components/common/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '2rem',
          textAlign: 'center',
          color: '#e2e8f0',
          background: 'rgba(30, 30, 30, 0.9)',
          borderRadius: '12px',
          margin: '2rem auto',
          maxWidth: '500px',
          border: '1px solid rgba(245, 101, 101, 0.3)',
        }}>
          <h3 style={{ color: '#fc8181', marginBottom: '1rem' }}>Something went wrong</h3>
          <p style={{ color: '#a0aec0', fontSize: '0.9rem', marginBottom: '1rem' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              background: 'rgba(102, 126, 234, 0.2)',
              color: '#667eea',
              border: '1px solid rgba(102, 126, 234, 0.4)',
              padding: '8px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
